import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const marqueeText = 'ЭНЕРГОГЛАЙД \u00A0•\u00A0 ';

export default function About() {
  return (
    <section className="section about" id="about">
      {/* Running ticker */}
      <div className="about__ticker">
        <div className="about__ticker-inner">
          {Array.from({ length: 12 }).map((_, i) => (
            <span key={i} className="about__ticker-item">{marqueeText}</span>
          ))}
        </div>
      </div>

      <div className="container about__grid">
        <motion.div
          className="about__left"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="tag">О КОМПАНИИ</div>
          <div className="section-divider" style={{ marginTop: 20 }} />
          <h2 className="section-title">
            Инжиниринг и <span>IT</span> — под одной крышей
          </h2>
          <p className="about__text">
            <strong>ООО «ЭНЕРГОГЛАЙД»</strong> — компания из Минска, основанная в ноябре 2025 года.
            Мы объединяем команду опытных инженеров и IT-специалистов, предлагая клиентам
            синергетический подход: от проектирования физической инфраструктуры до создания
            цифровых продуктов.
          </p>
          <p className="about__text">
            Мы проектируем системы электроснабжения, выполняем геодезические изыскания,
            разрабатываем архитектурные решения и дизайн интерьеров — и одновременно
            создаём веб-сайты, веб-приложения и кроссплатформенное desktop ПО.
          </p>
          <div className="about__badges">
            <span className="about__badge">🏙 Минск, Беларусь</span>
            <span className="about__badge">📅 Основана в 2025 году</span>
            <span className="about__badge">⚙️ Инжиниринг + IT</span>
          </div>
        </motion.div>

        <motion.div
          className="about__right"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          {[
            { num: '2', label: 'Ключевых направления: Инжиниринг и IT', icon: '⚙️' },
            { num: '3+', label: 'Платформы: Web, Windows, macOS, Linux', icon: '💻' },
            { num: '100%', label: 'Индивидуальный подход к каждому проекту', icon: '🤝' },
            { num: '10+', label: 'Лет суммарного опыта команды', icon: '⚡' },
          ].map((item, i) => (
            <motion.div
              key={i}
              className="about__card card"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 * i }}
            >
              <span className="about__card-icon">{item.icon}</span>
              <div>
                <div className="about__card-num">{item.num}</div>
                <div className="about__card-label">{item.label}</div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
